import { useGetQueryQP } from '@Inventory/AqlBuilder/helpers/common';
import { useInventoryCounts } from '@Inventory/services/use-inventory-counts';
import { Skeleton, Typography } from '@mui/material';
import { useMemo } from 'react';

interface InventoryCountsProps {
  type: 'resources' | 'entitlements' | 'permissions';
  noText?: boolean;
}

export default function InventoryCounts({ type = 'resources', noText }: InventoryCountsProps) {
  const query = useGetQueryQP();

  const { data, isFetching } = useInventoryCounts({
    query,
  });

  const countElem = useMemo(() => {
    if (!data || isFetching) {
      return (
        <Skeleton variant="text" sx={{ fontSize: '14px', display: 'inline-block', width: '30px' }} component="span" />
      );
    }

    let count = 0;
    switch (type) {
      case 'resources':
        count = data?.inventoryCounts.resourcesCount;
        break;
      case 'entitlements':
        count = data?.inventoryCounts.entitlementsCount;
        break;
      case 'permissions':
        count = data?.inventoryCounts.permissionsCount;
        break;
      default:
        break;
    }

    if (count > 1000) {
      return <>1000+</>;
    }

    return <>{count}</>;
  }, [data, isFetching, type]);

  if (noText) {
    return countElem;
  }

  return (
    <Typography variant="caption" color="text.muted">
      Total {countElem} results
    </Typography>
  );
}
